"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Divider = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _dividerModule = _interopRequireDefault(require("./divider.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["className"];
var Divider = function Divider(_ref) {
  var className = _ref.className,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("hr", Object.assign({
    className: (0, _classnames.default)(_dividerModule.default['divider'], className)
  }, rest));
};
exports.Divider = Divider;